import type { MatchRule } from './matchRule';
import { additionRule } from './additionRule';
import { subtractionRule } from './subtractionRule';

// The endgame grind: every enemy is a random addition or subtraction problem.
// Both feeder rules store the answer as `value`, so identity matching holds.
export const mixedRule: MatchRule = {
  id: 'mixed',
  label: 'Mixed Drill',
  instructions: 'Add or subtract — fire the answer.',
  answerFor: (value) => value,
  displayFor: (value) => String(value),
  matches: (input, value) => input === value,
  generate: (rng) => (rng.chance(0.5) ? additionRule.generate!(rng) : subtractionRule.generate!(rng)),
};
